import React, { forwardRef, useEffect } from 'react';
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import { StyledTableCellPrint, StyledTableRow } from '../../reusableComponent/Reusables';
import qoiImg from '../../../images/print_header.png';
import trigaslogo from '../../../images/tri_gases.jpeg';
import styles from '../../../styles.module.css';

const LoadingSlipPrint = forwardRef(({ printDetails = {} }, ref) => {
  const {
    table_details = '[]',
    to_customer = 'N/A',
    delivery_address = 'N/A',
    contact_no = 'N/A',
    from_depot = 'N/A',
    entry_no = 'N/A',
    entry_date = 'N/A',
    po_no = 'N/A',
    po_date = 'N/A',
    so_no = 'N/A',
    so_date = 'N/A',
    invoice_no = 'N/A',
    vehicle_no = 'N/A',
    driver_name = 'N/A',
    prepared_by = 'N/A',
  } = printDetails || {};

  // Parse table_details safely
  let childRows = [];
  try {
    childRows = Array.isArray(table_details) ? table_details : JSON.parse(table_details || '[]');
  } catch (e) {
    console.warn('Invalid JSON in table_details:', table_details);
    childRows = [];
  }

  // Compute totals based on parsed data
  const totalCylinders = childRows.length;
  const totalQuantity = childRows.reduce((acc, row) => acc + (Number(row.quantity) || 0), 0);
  const productsSummary = [...new Set(childRows.map((row) => row.products))].join(', ') || 'N/A';

  useEffect(() => {
    document.title = entry_no ? `DC_${entry_no}` : 'Delivery_Challan';
  }, [entry_no]);

  return (
    <Box ref={ref} className="print-source" sx={{ margin: '30px' }}>
                     <Box sx={{ margin: '55px 15px 30px 15px', boxShadow: 'none', height: '90vh', backgroundColor: '#ffffff', paddingLeft: '20px !important' }}>

        {/* Top Content */}
       
          {/* Header */}
          <Grid container>
            <Grid
              item
              xs={12}
              style={{
                backgroundImage: `url(${qoiImg})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '60px',
                marginBottom: '8px',
              }}
            >
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ ml: 2, fontSize: '26px', fontWeight: 'bold', color: '#ffffff' }}>
                  Loading Slip
                </Typography>
                <img
                  src={trigaslogo}
                  alt="logo"
                  style={{ height: '60px', border: '2px solid #009f9a' }}
                />
              </Box>
            </Grid>

            {/* Company Info */}
            <Grid item xs={12}>
              <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>TRI GASES PVT. LTD.</Typography>
              <Typography sx={{ fontSize: '12px' }}>
                Office No - 601, 6th Floor, Amar Business Park, Baner, Opp Sadanand Resort, Pune - 411045, MAHARASHTRA
              </Typography>
              <Typography sx={{ fontSize: '12px' }}>Email - demotes1234@gmail.com</Typography>
              <Typography sx={{ fontSize: '12px' }}>Website - www.trigases.com</Typography>
              <Typography sx={{ fontSize: '12px' }}>GSTIN - 27AADCT2097G1Z7</Typography>
            </Grid>
          </Grid>

          <Box sx={{ borderTop: '1px solid #616161', backgroundColor: '#f0f0f0', mt: 2, mb: 2 }} />

          {/* Table */}
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`} sx={{ boxShadow: 'none',marginBottom:'10px' }}>   
                     <Table size="small">
            <TableHead>
              <StyledTableRow>
                <StyledTableCellPrint align="center">Sr No</StyledTableCellPrint>
                <StyledTableCellPrint align="center">Customer</StyledTableCellPrint>
                <StyledTableCellPrint align="center">Cylinder No</StyledTableCellPrint>
                <StyledTableCellPrint align="left">Product Code</StyledTableCellPrint>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {childRows.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCellPrint align="center">{index + 1}</StyledTableCellPrint>
                  <StyledTableCellPrint align="center">{to_customer}</StyledTableCellPrint>
                  <StyledTableCellPrint align="center">{row.cyl_no}</StyledTableCellPrint>
                  <StyledTableCellPrint align="left">{row.prod_code}</StyledTableCellPrint>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          </TableContainer>
        







        <Box className={`${styles.footer}`}>
          <Table className={`${styles.footerTable}`}>
            <TableBody>
              <TableRow>
                <TableCell sx={{ paddingLeft: '0px !important', marginLeft: '0px !important', paddingRight: '0px !important', marginRight: '0px !important' }}>
                  <Box sx={{ padding: '0px !important', margin: '0px !important' }}>
                    <Box className={`${styles.summaryItem}`}
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                      }}
                    >
                      <Typography className={`${styles.label_Txt_add}`}>
                        Total Cyl:
                      </Typography>
                      <Typography className={`${styles.summary_ans}`}>
                        {totalCylinders || '0'}
                      </Typography>
                    </Box>
                    <Box className={`${styles.summaryItem}`}
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                      }}
                    >
                      <Typography className={`${styles.label_Txt_add}`}>
                        Total Qty:
                      </Typography>
                      <Typography className={`${styles.summary_ans}`}>
                        {totalQuantity || '0'}
                      </Typography>
                    </Box>
                    <Box className={`${styles.summaryItem}`}
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                      }}
                    >
                      <Typography className={`${styles.label_Txt_add}`}>
                        Products:
                      </Typography>
                      <Typography className={`${styles.summary_ans}`}>
                        {productsSummary || 'None'}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell>
                  <Box>
                    <Typography className={`${styles.footer_txt}`}>
                      For{' '}
                      <span className={`${styles.footer_txt_bold}`}>
                        TRI GASES PVT. LTD.
                      </span>
                    </Typography>
                    <Box sx={{}}>
                      <Typography className={`${styles.authorized_txt}`}>
                        Authorized Signatory
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>










      </Box>
    </Box>
  );
});

export default LoadingSlipPrint;
